import React, {useState, useEffect, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_state_new, 
  options_approval_new, 
  options_targeting,
  valueToOption
} from "../../atom/Apollo_styles";
import {
  accountgroups_path,
  accounteditapollo_path,
  apollo_account_path,
  apollo_account_accountgroup_path,
  hera_tracker_path,
  accountgroupdetail_path,
  apollo_account_approval_path,
  isummary_path, apollo_accounts_trackerid_migration_active_path,
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  ApolloAccount,
  ApolloAccountApproveRequest, TrackerIdMigrationSourceAccountInfo,
} from "../../organism/ACCOUNT/AccountModel";
import ApolloAccountMenuList from "../../organism/ACCOUNT/Apollo_AccountMenuList";

import {Link, useHistory, useLocation, useParams} from "react-router-dom";

import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";

import Fab from "@material-ui/core/Fab";
import EditIcon from '@material-ui/icons/Edit';

import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";

import moment from "moment";
import {DeleteButton} from "../../molecule/Apollo_Button";
import Grid from "@material-ui/core/Grid";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloUserProfileAuth, APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR, APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_ADMIN, APOLLO_GROUP_OPERATOR, IsAuthorization} from "../../atom/Apollo_Authorization";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Tooltip from '@material-ui/core/Tooltip';

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_DETAIL,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

const btnWrapper = {
  margin: "0 0 8px 0",
}

/*
    画面名：アカウント詳細（アポロ）画面
 */
const AccountDetailApollo: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  // 0: 新規　、　id：編集
  const {accountid} = useParams<{accountid: string}>();
  const {accountgroupid} = useParams<{accountgroupid: string}>();
  const {state, dispatch} = React.useContext(ApolloContext);

  const {data, setmsg} = React.useContext(ApolloMessage);
  const [account, setAccount] = useState<ApolloAccount>();
  const [openPlatform, setOpenPlatform] = useState(false);
  const processing = useRef(false);
  const [redisplay, setRedisplay] = useState(false);

  const [trackerIdMigrationAccount, setTrackerIdMigrationAccount] = useState<TrackerIdMigrationSourceAccountInfo>();

  // 操作前データ
  const beforeData = useRef<any>(null);
  const requestData = useRef<any>(null);
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード

  const QUERY_NAME_1 = "type";  // クエリパラメータ名

  const QUERY_TYPE_1 = "de";  // アカウントグループ詳細から
  const QUERY_TYPE_2 = "li";  // アカウントグループ一覧から
  const QUERY_TYPE_3 = "ad";  // 広告グループ一覧から
  const QUERY_TYPE_4 = "ca";  // キャンペーン一覧から
  const QUERY_TYPE_5 = "ap";  // 未承認アカウントから
  const query1 = new URLSearchParams(useLocation().search);
  const queryType = query1.has(QUERY_NAME_1) ? query1.get(QUERY_NAME_1) : QUERY_TYPE_3;

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 10,
    breadId: queryType === QUERY_TYPE_1 || queryType === QUERY_TYPE_2 || queryType === QUERY_TYPE_5 ? 2 : queryType === QUERY_TYPE_3 ? 3 : queryType === QUERY_TYPE_4 ? 4 : 2,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const   products1 = [
    {name: 'アカウントグループID', desc: '', value: account?.accountgroupId},
    {name: 'アカウントグループ名', desc: '', value: account?.accountgroupName},
    {name: '広告主アカウントID', desc: '', value: account?.accountId},
    {name: '広告主アカウント名', desc: '', value: account?.accountName},
    {name: '広告主名', desc: '', value: account?.advertiserName},
    {name: 'アカウント月額予算', desc: '', value: "￥" + (account?.budgetAmount ? account?.budgetAmount.toLocaleString() : 0)},
    {name: 'ステータス', desc: '', value: account?.status ? valueToOption(account?.status, options_state_new).label : ""},
  ];
  const   products2 = [
    // {name: '承認状況', desc: '', value: account?.approval ? valueToOption(account?.approval, options_approval_new).label : "", isDisplay: isAuthorization},
    {name: '作成日時', desc: '', value: account?.createdAt ? moment(account?.createdAt).format("YYYY-MM-DD HH:mm") : "", isDisplay: isAuthorization},
    {name: '更新日時', desc: '', value: account?.modifiedAt ? moment(account?.modifiedAt).format("YYYY-MM-DD HH:mm") : "", isDisplay: isAuthorization},
  ];
  const   products3 = [
    {name: '商品名称', desc: '', value: account?.productName, isDisplay: isAuthorization},
    {name: '業種', desc: '', value: account?.industoryName, isDisplay: isAuthorization},
    {name: 'URL', desc: '', value: account?.url, isDisplay: isAuthorization},
    // {name: 'スゴ得ターゲティング使用可否', desc: '', value: account?.targetingFlg ? valueToOption(account?.targetingFlg, options_targeting).label : "", isDisplay: isAuthorization},
  ];

  // トラッカーID移行対応
  const isIncludeMigrationSourceAccountGroups = (process.env.REACT_APP_TRACKERID_MIGRATION_SOURCE_ACCOUNT_GROUPS ?? "").split(",").includes(String(state.current.accountGroupId));
  const [isNotDestinationActiveAccount, setIsNotDestinationActiveAccount] = useState(true)


  useEffect(() => {
    const url = apollo_account_accountgroup_path + "/" + accountgroupid + "/" + accountid;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        // 操作前データ保存
        beforeData.current = JSON.parse(JSON.stringify(response.data.result));
        setAccount(response.data.result);
        const tId = response.data.result.trackerId ? response.data.result.trackerId : "";
        dispatch({
          type: "setTrackerId",
          payload: {
            ...state,
            current: {
              ...state.current,
              trackerId: tId,
            }
          }
        });
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_DETAIL,"E","1"),
            loading: false,
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_DETAIL,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // トラッカーID移行情報を取得する。
    const urlTrackerIdMigration = apollo_accounts_trackerid_migration_active_path + "/" + accountid;
    ApolloAxios.get(urlTrackerIdMigration).then(response => {
      if (response.data.resultCode === 0) {

        if(response.data.result?.migration_id) {
          const intAccountid = Number(accountid);
          const elem = response.data.result;
          const migrationType = elem.source_account_id === intAccountid ? 2 : 1;
          const record:TrackerIdMigrationSourceAccountInfo = {
            accountgroupId: migrationType === 1 ? elem.source_account_group_id : elem.destination_account_group_id,
            accountgroupName: migrationType === 1 ? elem.source_account_group_name : elem.destination_account_group_name,
            accountId: migrationType === 1 ? elem.source_account_id : elem.destination_account_id,
            accountName: migrationType === 1 ? elem.source_account_name : elem.destination_account_name,
            type: migrationType
          }
          setTrackerIdMigrationAccount(record)
          setIsNotDestinationActiveAccount(record.type === 2);
        }
      } else {
        var errMessage = GetMessage("0",UI_ACCOUNT_DETAIL,"E","5");
        errMessage += response.data.message && " (" + response.data.message + ")";
        console.log(errMessage);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMessage,
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_DETAIL,"E","5"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [redisplay]);

  // アカウント削除API
  const handleDelete = async () => {
    if (processing.current) return;
    processing.current = true;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(削除)
    actionType.current = 3;
    writeLog();
    
    const url = apollo_account_path + "/" + accountgroupid + "/" + accountid;
    await ApolloAxios.delete(url).then(response => {
      if (response.data.resultCode === 0) {
        // 操作ログ(成功)
        resultApi.current = 1;
        resultData.current = response.data.current;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_ACCOUNT_DETAIL,"I","0"),
          }
        });
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            current: {
              ...state.current,
              accountId: 0,
              accountName: "",
              trackerId: "",
              campaignId: 0,
            },
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          }
        });
        history.push(accountgroupdetail_path + accountgroupid);
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
        var errMessage = GetMessage("0",UI_ACCOUNT_DETAIL,"E","2");
        errMessage += response.data.message && " (" + response.data.message + ")";
        console.log(errMessage);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMessage,
          }
        });
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_DETAIL,"E","2"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  };

  // 承認状況更新API
  const updateApproval = (async (body: any) => {
    if (processing.current) return;
    processing.current = true;
    let approvalValue = body + "" ;
    let accountId:number[] =  [account?.accountId ? account.accountId : 0];
    const url = apollo_account_approval_path;
    const agReq: ApolloAccountApproveRequest = {
      accountId: accountId,
      approval: approvalValue,
    }
    // 操作ログ用にリクエストデータ保存
    requestData.current = agReq;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(更新・承認)
    actionType.current = 2;
    writeLog();
    
    ApolloAxios.put(url, agReq).then(response => {
      if (response.data.resultCode === 0) {
        // 操作ログ(成功)
        resultApi.current = 1;
        resultData.current = response.data.current;
        
        setRedisplay(!redisplay)
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_ACCOUNT_DETAIL,"I","1"),
          },
        });
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          },
        });
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_DETAIL,"E","3"),
          },
        });
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_DETAIL,"E","3"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  });

  // 戻るボタンハンドラ
  const handelGoback = () => {
    var url = accountgroups_path;
    if (queryType === QUERY_TYPE_1) {
      url = accountgroupdetail_path + accountgroupid +"?"  + QUERY_NAME_1 + "=" + QUERY_TYPE_2;
    } else if (queryType === QUERY_TYPE_2) {
      url = accountgroups_path;
    } else if (queryType === QUERY_TYPE_3) {
      url = accountgroupdetail_path + accountgroupid;
    } else if (queryType === QUERY_TYPE_4) {
      url = isummary_path;
    } else if (queryType === QUERY_TYPE_5) {
      url = accountgroups_path + "?" + QUERY_NAME_1 + "=" + QUERY_TYPE_5;
    }
    history.push(url);
  };

  const handelUnapproval = () => {
    updateApproval(1);
  };
  const handelApproval = () => {
    updateApproval(2);
  };
  const handelNoapproval = () => {
    updateApproval(3);
  };

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    var key = "";
    var beforeValue = "";
    var afterValue = "";
    switch (actionType.current) {
      case 0: // 参照
        break;
      case 1: // 新規
        break;
      case 2: // 更新
        key = "承認状況";
        beforeValue = valueToOption(Number(beforeData.current.approval), options_approval_new).label + "";
        afterValue = valueToOption(Number(requestData.current.approval), options_approval_new).label + "";
        break;
      case 3: // 削除
        key = "論理削除フラグ";
        beforeValue = "0";
        afterValue = "1";
        break;
      case 4: // アップロード
        break;
      default: // 不明
        key = "不明";
    }
    const itemList: ItemList[] = [
      {
        key: key,
        beforeValue: beforeValue,
        afterValue: afterValue,
      },
    ];
    // 項目リスト
    const itemListDelete: ItemList[] = [];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: account ? account.accountId: 0, // 広告主アカウントID
      accountName: account ? account.accountName : "", // 広告主アカウント名
      campaignID: "",
      campaignName: "",
      adGroupID: "",
      adGroupName: "",
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "広告主アカウント詳細画面", // 操作画面名称 〇〇画面
      category: "広告主アカウント", // 操作対象 キャンペーン / セグメント etc...
      actionType: actionType.current === 0 ? "参照" : actionType.current === 1 ? "作成" : actionType.current === 2 ? "更新" : actionType.current === 3 ? "削除" : actionType.current === 4 ? "アップロード" : "不明", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : actionType.current === 3 ? account ? account.accountId + "" : "" : state.current.accountId + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "広告主アカウントID", // 操作を行うデータの名称 実行時は空文字
      itemList: actionType.current === 3 ? itemListDelete : itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  return (
    <GenericTemplate title="">
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Tooltip title="広告主アカウント編集" placement="top">
          <Fab color="primary" aria-label="edit" className={classes.fab2}>
            <Link to={accounteditapollo_path + accountgroupid + "/" + accountid} className={classes.link}>
              <EditIcon/>
            </Link>
          </Fab>
        </Tooltip>
        <Tooltip title="広告主アカウント削除" placement="top">
          <Fab color="primary" aria-label="del" className={classes.fab}>
            <DeleteButton handleDelete={handleDelete} title="広告主アカウント削除" text={`この広告主アカウントを削除しますか？`}/>
          </Fab>
        </Tooltip>
      </ApolloUserProfileAuth>

      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3} style={{marginBottom: "5px"}}>
              {products1?.map((product, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={6}>
                    <Typography>{product.name}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{product.value}</Typography>
                  </Grid>
                </React.Fragment>
              ))}
              {isAuthorization
                ? <React.Fragment>
                  <Grid item xs={6}>
                    <Typography>承認状況</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography>
                      {account?.approval ? valueToOption(account?.approval, options_approval_new).label : ""}
                    </Typography>
                  </Grid>
                  {!isIncludeMigrationSourceAccountGroups ?
                    <Grid item xs={4}>
                    <ApolloUserProfileAuth role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
                      <Typography>
                        {(account?.approval === 1) &&
                          <Button className={classes.buttonTop} disabled={!isNotDestinationActiveAccount} variant="contained" color="primary" onClick={handelApproval}>
                            承認
                          </Button>
                        }
                        {(account?.approval === 3) &&
                          <Button className={classes.buttonTop} variant="contained" color="primary" onClick={handelUnapproval}>
                            再申請
                          </Button>
                        }
                        {(account?.approval === 1) &&
                          <Button className={classes.buttonTop} disabled={!isNotDestinationActiveAccount} variant="contained" color="primary" onClick={handelNoapproval}>
                            非承認
                          </Button>
                        }
                      </Typography>
                    </ApolloUserProfileAuth>
                  </Grid>
                 : <></> }
                  </React.Fragment>
                : null
              }
              {products2?.map((product, index) => {
                return(
                  product.isDisplay
                  ? <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <Typography>{product.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>{product.value}</Typography>
                    </Grid>
                  </React.Fragment>
                  : null
                )
              })}
              <Grid item xs={6}>
                <Typography>トラッカーID</Typography>
              </Grid>
              <Grid item xs={6}>
                {isNotDestinationActiveAccount ?
                <Tracker trackerId={account?.trackerId} accountId={account?.accountId}/> : <Typography>移行予定</Typography> }
              </Grid>
              {products3?.map((product, index) => {
                return(
                  product.isDisplay
                  ? <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <Typography>{product.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>{product.value}</Typography>
                    </Grid>
                  </React.Fragment>
                  : null
                )
              })}
            </Grid>

            <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
              <Grid container spacing={3} style={{marginBottom: "5px"}}>
                <Grid item xs={6}>
                  <Typography>スゴ得ターゲティング使用可否</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{account?.targetingFlg ? valueToOption(account?.targetingFlg, options_targeting).label : ""}</Typography>
                </Grid>
              </Grid>
            </ApolloUserProfileAuth>
            <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
              <Grid container spacing={3} style={{marginBottom: "5px"}}>
                <Grid item xs={6}>
                  <Typography>媒体運用プラン利用状況</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{account?.d2cOperationFlg ? "利用中" : ""}</Typography>
                </Grid>
              </Grid>
            </ApolloUserProfileAuth>

            {trackerIdMigrationAccount ?
            <Grid container spacing={3} style={{marginBottom: "5px"}}>
              <Grid item xs={6}>
                <Typography>{trackerIdMigrationAccount.type === 1 ? "トラッカーID移行元" : "トラッカーID移行先"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>アカウントグループID：{trackerIdMigrationAccount.accountgroupId}</Typography>
                <Typography>アカウントID：{trackerIdMigrationAccount?.accountId}</Typography>
                <Typography>{trackerIdMigrationAccount.type === 1 ? "移行元アカウント名" : "移行先アカウント名"}：{trackerIdMigrationAccount?.accountName}</Typography>
              </Grid>
            </Grid> : <></> }

            <Divider/>

            <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px"}}>
              メニュー
            </Typography>

            <IconButton aria-label="expand row" size="small" onClick={() => setOpenPlatform(!openPlatform)}>
              {openPlatform ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>

            {/* アカウントメニューリスト */}
            <ApolloAccountMenuList account={account} openPlatform={openPlatform} setOpenPlatform={setOpenPlatform}/>

          </CardContent>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

function Tracker(props: { trackerId: string | undefined, accountId: number | undefined }) {

  const {accountid} = useParams<{accountid: string}>();
  const classes = apollo_useStyles();
  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [trackerId, setTrackerId] = useState("");
  const processing = useRef(false);
  const accountId = props.accountId;
  // 操作前データ
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");

  useEffect(() => {
    props.trackerId && setTrackerId(props.trackerId);
  }, [props.trackerId]);

  const handelGetTrackerId = async () => {
    if (processing.current) return;
    processing.current = true;

    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログ出力(実行)
    writeLog();

    const url = hera_tracker_path + "/" + accountid;
    ApolloAxios.put(url, null).then(response => {
      const data = response.data;
      setTrackerId(data.trackerId);
      resultData.current = data.trackerId;
      // 操作ログ(成功)
      resultApi.current = 1;
      dispatch({
        type: "setTrackerId",
        payload: {
          ...state,
          apolloList: data.context.apolloList,
          current: {
            ...state.current,
            trackerId: data.trackerId,
          }
        }
      });
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: GetMessage("0",UI_ACCOUNT_DETAIL,"I","2"),
        }
      });
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_ACCOUNT_DETAIL,"E","4"),
        }
      });
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  }

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    const itemList: ItemList[] = [
      {
        key: "トラッカーID",
        beforeValue: "",
        afterValue: resultData.current ? resultData.current === 0 ? "" : resultData.current + "" : "",
      },
    ];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:MM:SS“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: accountId ? accountId: 0, // 広告主アカウントID
      accountName: state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "広告主アカウント詳細画面", // 操作画面名称 〇〇画面
      category: "広告主アカウント", // 操作対象 キャンペーン / セグメント etc...
      actionType: "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : resultData.current + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "トラッカーID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  if (trackerId !== "") {
    return <Typography>{trackerId}</Typography>
  } else {
    return (
      <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <Button
          variant="contained"
          color="primary"
          style={btnWrapper}
          onClick={handelGetTrackerId}
          className={classes.button}
          disabled={!accountId}
        >
          取得
        </Button>
      </ApolloUserProfileAuth>
    )
  }
}

export default AccountDetailApollo;
